module.exports = __webpack_public_path__ + "img/icon-51.ad0e2e44.svg";